import Grid from "@mui/material/GridLegacy"
import Typography from "@mui/material/Typography"



const TypographyGridCol = ({ children, title, subtitle, gridProps = { xs: 12, lg: 6 } }) => {
    return (
        <Grid {...gridProps} item>
            <Typography className="text-center mb-3" sx={{
                marginTop: {
                    lg: 0,
                    xs: '0.5rem'
                }
            }} component="h3" variant="h3">{title}</Typography>
            <Typography className="text-center mb-3" component="p" variant="p">{subtitle}</Typography>
            {children}
        </Grid>
    )
}

export default TypographyGridCol